import { useMutation } from "react-query";
import getEStatement from "../services/getEStatement";

const useGetEStatementMutation = () => {
  return useMutation(["get-e-statement"], getEStatement);
};

export default useGetEStatementMutation;
